/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Duration_ShortInputs */



/**
* | output |
* | --- |
* | "DURA" |
*
* @param {Ccsl_Export_Header_Duration_ShortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_duration_short = /** @type {((inputs?: Ccsl_Export_Header_Duration_ShortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Duration_ShortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("DUREE")
	if (locale === "de") return /** @type {LocalizedString} */ ("DURA")
	if (locale === "it") return /** @type {LocalizedString} */ ("DURA")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ДУРА")
	if (locale === "es") return /** @type {LocalizedString} */ ("DURA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("杜拉")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デュラ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ड्यूरा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("DURA")
	return /** @type {LocalizedString} */ ("DURA")
});